var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "search-term" },
        [
          _c(
            "el-form",
            { attrs: { inline: true, model: _vm.searchInfo } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "注册方式" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { clearable: "", placeholder: "请选择" },
                      model: {
                        value: _vm.searchInfo.identityType,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "identityType", $$v)
                        },
                        expression: "searchInfo.identityType"
                      }
                    },
                    _vm._l(_vm.identityTypeDict, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.title, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "注册信息" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "手机号/用户名/储值卡号",
                      clearable: ""
                    },
                    model: {
                      value: _vm.searchInfo.identifier,
                      callback: function($$v) {
                        _vm.$set(_vm.searchInfo, "identifier", $$v)
                      },
                      expression: "searchInfo.identifier"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "用户UID" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "text",
                      placeholder: "用户UID",
                      clearable: ""
                    },
                    model: {
                      value: _vm.searchInfo.uidString,
                      callback: function($$v) {
                        _vm.$set(_vm.searchInfo, "uidString", $$v)
                      },
                      expression: "searchInfo.uidString"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "用户群:" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        filterable: "",
                        placeholder: "请选择",
                        clearable: ""
                      },
                      model: {
                        value: _vm.searchInfo.userGroupId,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "userGroupId", $$v)
                        },
                        expression: "searchInfo.userGroupId"
                      }
                    },
                    _vm._l(_vm.userGroupOptions, function(item) {
                      return _c("el-option", {
                        key: item.ID,
                        attrs: {
                          label: item.groupName + item.parentName,
                          value: item.ID
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "注册开始" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "datetime",
                      format: "yyyy-MM-dd HH:mm:ss",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      placeholder: "注册开始时间",
                      clearable: ""
                    },
                    model: {
                      value: _vm.searchInfo.registerStart,
                      callback: function($$v) {
                        _vm.$set(_vm.searchInfo, "registerStart", $$v)
                      },
                      expression: "searchInfo.registerStart"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "注册结束" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "datetime",
                      format: "yyyy-MM-dd HH:mm:ss",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      placeholder: "注册结束时间",
                      clearable: ""
                    },
                    model: {
                      value: _vm.searchInfo.registerEnd,
                      callback: function($$v) {
                        _vm.$set(_vm.searchInfo, "registerEnd", $$v)
                      },
                      expression: "searchInfo.registerEnd"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "是否支付" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { clearable: "", placeholder: "请选择" },
                      model: {
                        value: _vm.searchInfo.isPayed,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "isPayed", $$v)
                        },
                        expression: "searchInfo.isPayed"
                      }
                    },
                    [
                      _c("el-option", {
                        key: 1,
                        attrs: { label: "已支付", value: 1 }
                      }),
                      _c("el-option", {
                        key: 2,
                        attrs: { label: "未支付", value: 2 }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "是否有储值卡" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { clearable: "", placeholder: "请选择" },
                      model: {
                        value: _vm.searchInfo.isHasSvcCard,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "isHasSvcCard", $$v)
                        },
                        expression: "searchInfo.isHasSvcCard"
                      }
                    },
                    [
                      _c("el-option", {
                        key: 1,
                        attrs: { label: "是", value: 1 }
                      }),
                      _c("el-option", {
                        key: 2,
                        attrs: { label: "否", value: 2 }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                    [_vm._v("查询")]
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("el-button", { on: { click: _vm.onReset } }, [
                    _vm._v("重置")
                  ])
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.onAddGroupUser }
                    },
                    [_vm._v("加入会员群")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            border: "",
            stripe: "",
            "tooltip-effect": "dark"
          },
          on: { "selection-change": _vm.handleSelChange }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "ID", width: "40", type: "selection" }
          }),
          _c("el-table-column", {
            attrs: { type: "expand", "header-": "" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(props) {
                  return [
                    _c(
                      "el-form",
                      {
                        staticClass: "demo-table-expand",
                        attrs: { "label-position": "left", inline: "" }
                      },
                      [
                        _c("el-form-item", { attrs: { label: "微信信息" } }, [
                          _c("span", [_vm._v(_vm._s(props.row.unionId))])
                        ]),
                        _c("el-form-item", { attrs: { label: "性别" } }, [
                          _c("span", [_vm._v(_vm._s(props.row.gender))])
                        ]),
                        _c("el-form-item", { attrs: { label: "生日" } }, [
                          _c("span", [_vm._v(_vm._s(props.row.birth))])
                        ]),
                        _c("el-form-item", { attrs: { label: "邮箱" } }, [
                          _c("span", [_vm._v(_vm._s(props.row.email))])
                        ]),
                        _c("el-form-item", { attrs: { label: "经纬度" } }, [
                          _c(
                            "span",
                            [
                              _vm._v("经度："),
                              props.row.longitude
                                ? _c("el-tag", { attrs: { size: "mini" } }, [
                                    _vm._v(_vm._s(props.row.longitude))
                                  ])
                                : _vm._e(),
                              _vm._v(" 纬度："),
                              props.row.latitude
                                ? _c("el-tag", { attrs: { size: "mini" } }, [
                                    _vm._v(_vm._s(props.row.latitude))
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        ]),
                        _c("el-form-item", { attrs: { label: "油站区域" } }, [
                          _c(
                            "span",
                            [
                              _vm._v("省份："),
                              props.row.provinceName
                                ? _c(
                                    "el-tag",
                                    {
                                      attrs: { size: "mini", type: "success" }
                                    },
                                    [_vm._v(_vm._s(props.row.provinceName))]
                                  )
                                : _vm._e(),
                              _vm._v(" 城市："),
                              props.row.cityName
                                ? _c(
                                    "el-tag",
                                    {
                                      attrs: { size: "mini", type: "success" }
                                    },
                                    [_vm._v(_vm._s(props.row.cityName))]
                                  )
                                : _vm._e(),
                              _vm._v(" 区域："),
                              props.row.districtName
                                ? _c(
                                    "el-tag",
                                    {
                                      attrs: { size: "mini", type: "success" }
                                    },
                                    [_vm._v(_vm._s(props.row.districtName))]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ])
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "uidString", prop: "uidString", "header-": "" }
          }),
          _c("el-table-column", {
            attrs: {
              label: "注册时间",
              prop: "user.CreatedAt",
              width: "160",
              "header-": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      _vm._s(_vm._f("formatDate")(scope.row.user.CreatedAt))
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "注册方式", prop: "identityType", "header-": "" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.identityType
                      ? _c(
                          "el-tag",
                          {
                            attrs: {
                              size: "mini",
                              type: _vm._f("formatIdentityType")(
                                scope.row.identityType,
                                "tag"
                              )
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm._f("formatIdentityType")(
                                  scope.row.identityType,
                                  "title"
                                )
                              )
                            )
                          ]
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "用户名", prop: "user.username", "header-": "" }
          }),
          _c("el-table-column", {
            attrs: { label: "手机号", prop: "user.mobile", "header-": "" }
          }),
          _c("el-table-column", {
            attrs: { label: "会员群组", prop: "groupName", "header-": "" }
          }),
          _c("el-table-column", {
            attrs: {
              label: "注册来源",
              prop: "user.registerSource",
              "header-": ""
            }
          }),
          _c("el-table-column", {
            attrs: { label: "会员码", prop: "user.userCode", "header-": "" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.onViewQrcode(scope.row.user.userCode)
                          }
                        }
                      },
                      [_vm._v("查看")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("el-pagination", {
        style: { float: "right", padding: "20px" },
        attrs: {
          "current-page": _vm.page,
          "page-size": _vm.pageSize,
          "page-sizes": [10, 30, 50, 100],
          total: _vm.total,
          layout: "total, sizes, prev, pager, next, jumper"
        },
        on: {
          "current-change": _vm.handleCurrentChange,
          "size-change": _vm.handleSizeChange
        }
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.closeDialog,
            visible: _vm.qrcodeDialogVisible,
            title: "会员码"
          },
          on: {
            "update:visible": function($event) {
              _vm.qrcodeDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-row",
            [
              _c("el-col", { attrs: { span: 4 } }, [_vm._v(" ")]),
              _c(
                "el-col",
                {
                  staticStyle: { "text-align": "center" },
                  attrs: { span: 16 }
                },
                [
                  _c("vue-qr", {
                    attrs: {
                      logoSrc: _vm.bairunLogo,
                      text: _vm.userQrcodeText,
                      size: 350
                    }
                  })
                ],
                1
              ),
              _c("el-col", { attrs: { span: 4 } }, [_vm._v(" ")])
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("关闭")
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { title: "加入会员群组", visible: _vm.userGroupDialogVisible },
          on: {
            "update:visible": function($event) {
              _vm.userGroupDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "formData",
              attrs: { model: _vm.formData, rules: _vm.rules }
            },
            [
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: 6 } }, [_vm._v(" ")]),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "手机号",
                                    prop: "mobile",
                                    "label-width": "80px"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      autocomplete: "off",
                                      disabled: true
                                    },
                                    model: {
                                      value: _vm.formData.mobile,
                                      callback: function($$v) {
                                        _vm.$set(_vm.formData, "mobile", $$v)
                                      },
                                      expression: "formData.mobile"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "用户群:",
                                    prop: "userGroupId",
                                    "label-width": "80px"
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        filterable: "",
                                        placeholder: "请选择",
                                        clearable: ""
                                      },
                                      model: {
                                        value: _vm.formData.userGroupId,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "userGroupId",
                                            $$v
                                          )
                                        },
                                        expression: "formData.userGroupId"
                                      }
                                    },
                                    _vm._l(_vm.userGroupOptions, function(
                                      item
                                    ) {
                                      return item.parentId != 29
                                        ? _c("el-option", {
                                            key: item.ID,
                                            attrs: {
                                              label:
                                                item.groupName +
                                                item.parentName,
                                              value: item.ID
                                            }
                                          })
                                        : _vm._e()
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("el-col", { attrs: { span: 6 } }, [_vm._v(" ")])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.enterDialog } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }